import type { Service, ServicePage, ServicePageOption } from 'api/api.types'

/** Service options of a page; a page saved before options existed has its one service as the only option */
export const getPageOptions = (page: ServicePage | null | undefined): ServicePageOption[] => {
  const vars = page?.templateVars?.pageVars
  if (!vars) {
    return []
  }
  if (vars.services?.length) {
    return vars.services
  }
  return vars.service ? [{ title: '', service: vars.service }] : []
}

/** The option title of a service when its page offers several options, otherwise an empty string */
export const getServiceOptionTitle = (service: Pick<Service, 'id' | 'meta'>): string => {
  const options = getPageOptions(service.meta)
  if (options.length < 2) {
    return ''
  }
  return options.find((option) => option.service.id === service.id)?.title ?? ''
}

/** Page title of a service, with the option title when the page has several options */
export const getServiceName = (service: Pick<Service, 'id' | 'meta'>): string | undefined => {
  const title = service.meta?.title
  const optionTitle = getServiceOptionTitle(service)
  return title && optionTitle ? `${title} · ${optionTitle}` : title
}
